export const API_CONFIGURATIONS = 'API_CONFIGURATIONS'
export const LOAD_START = 'LOAD_START'
export const UPDATE_PROGRESS = 'UPDATE_PROGRESS'
export const LOAD_COMPLETE = 'LOAD_COMPLETE'
export const NEW_API = 'NEW_API'
export const NEW_OPERATION = 'NEW_OPERATION'
export const NEW_DEFINITION = 'NEW_DEFINITION'
export const RESPONSE_RECEIVED = 'RESPONSE_RECEIVED'
export const SEND_REQUEST = 'SEND_REQUEST'

export const CONFIG_URL = 'CONFIG_URL'
export const CONFIG_HEADERS = 'CONFIG_HEADERS'

export const SELECTED_OPERATION = 'SELECTED_OPERATION'

export const NEW_PARAMETERS = 'NEW_PARAMETERS'
export const LOCAL_PARAMETERS = 'LOCAL_PARAMETERS'



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js